import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=292a0632"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=292a0632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports